module.exports = __webpack_public_path__ + "static/9-77513c50c055d9a15e3c57d40c08a0a7.jpg";